import React, { useState, useRef } from 'react';
import InfoTracking from '@app/components/common/InfoTracking';
import { Button, Col, Switch, DatePicker, Drawer, Form, Input, Row, Select, InputNumber, Space, message, Modal } from 'antd';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import {insertDetail, getDetail, updateDetail} from '../../../../../apis/ParametrosApi';
import moment from 'moment';
import './styles.scss';
const App = ({title, parametroId, id, open, finish}) => {
    const [ form ] = Form.useForm()
    const [ID, setID] = useState(id);
    const [descripcion, setDescripcion] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [initialValues, setInitialValues] = useState(null);

    const handleOk = async () => {

        try {
            const values = await form.validateFields();
            if(!values) return;
        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
            return;
        }

        const fields = form.getFieldsValue()
        var defaultValue = {
        }

        let success = false;
        if(ID > 0){
            const payload = {
                id: ID,
                parametro_id: parametroId,
                ...defaultValue,
                ...fields
            }
            const response = await updateDetail(payload);
            success = response.ok;
            if(response.ok){
                message.success('Se guardo correctamente la linea!');
            }
        }else{
            const payload = {
                parametro_id: parametroId,
                ...fields
            }
            const response = await insertDetail(payload);
            success = response.ok;
            if(response.ok){
                message.success('Se guardo correctamente la linea!');
            }
        }
        
        if(success){
            setShowModal(false);
            finish(true);
        }
    }

    const onClose = ()=>{
        setShowModal(false);
        finish(false);
    }

    React.useEffect(() => {
        setShowModal(open);
    }, [open]);

    React.useEffect(() => {
        setID(id);
    }, [id]);


    const effectRan = useRef(false);
    React.useEffect(() => {

      if (!effectRan.current) {
        (async ()=>{
            if(ID > 0){
                await refreshData();
            }else{
                setInitialValues({
                    activo: true
                });
            }
        })()
      }
    
      return () => effectRan.current = true;
    }, [ID]);

    const refreshData = async ()=> {
        if(ID > 0){
            const response = await getDetail(ID);
            if(response.ok){
                let detail = response.payload;
                setInitialValues(detail);
            }
        }else{
            setInitialValues({
                activo: true
            });
        }
    }

  return (
    <>
      <Drawer
        title={title}
        width={720}
        placement={"right"}
        onClose={onClose}
        open={open}
        closable={true}
        height={'80%'}
        onFinish={handleOk}
        styles={{
          body: {
            paddingBottom: 80,
          },
        }}
        extra={[
            <Space>
                {ID && <InfoTracking entity={'ConfiguracionPeriodoDetalle'} entityId={ID}/>}
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={handleOk} type="primary">
                Guardar
                </Button>
            </Space>
        ]}
      >
        {
            initialValues && 
            <Form layout="vertical" form={form} hideRequiredMark onFinish={handleOk} initialValues={initialValues}>
                <Row gutter={16}>
                    <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                        <Form.Item
                            name="porcentaje_maximo"
                            label="Porcentaje Maximo"
                            rules={[
                            {
                                required: true,
                                message: 'Por favor agrega los días del periodo',
                            },
                            ]}>
                            <InputNumber placeholder="Por favor agrega los días del periodo" style={{width: '80%',}}/>
                        </Form.Item>
                    </Col>
                    <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                        <Form.Item
                            name="incluir_neto_negativo"
                            label="Incluir neto negativo"
                        >
                            <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />}/>
                        </Form.Item>
                    </Col>
                    <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                        <Form.Item
                            name="valor_redondeo_neto"
                            label="Valor redondeo neto"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor agrega un valor',
                                },
                            ]}
                            >
                            <InputNumber placeholder="Por favor agrega un valor" style={{width: '80%',}}/>
                        </Form.Item>
                    </Col>
                    <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                        <Form.Item
                            name="llevar_saldo_redondeo"
                            label="Llevar saldo redondeo"
                           >
                            <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />}/>
                        </Form.Item>
                    </Col>
                    <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                        <Form.Item
                            name="aplicar_deducciones_no_destadas"
                            label="Aplicar deducciones no descontadas"
                           >
                            <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />}/>
                        </Form.Item>
                    </Col>
                    <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                        <Form.Item
                            name="activo"
                            label="Activo"
                            >
                            <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />}/>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        }
      </Drawer>
    </>
  );
};
export default App;